module.exports = __webpack_public_path__ + "static/media/verified_email.e9bc3b93.svg";